module.exports = __webpack_public_path__ + "img/spiceblendsSmall.1aa9a249.jpg";